function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 33 30",
  height: "16",
  width: "16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24.33 30c-.33 0-.65-.02-.99-.07-7.57-1.1-7.9-7.3-8.2-14.1-.23-5.55-.47-9.8-4.23-11.99A6.17 6.17 0 005.9 3.3a4.88 4.88 0 00-3 2.78A1.5 1.5 0 11.1 4.94 7.84 7.84 0 014.94.46a9.2 9.2 0 017.49.79c5.16 3.03 5.46 8.39 5.71 14.45.32 7.48.86 10.57 5.63 11.26 2.63.37 4.74-2.01 6.49-4.4a1.5 1.5 0 012.42 1.77C31.4 26.08 28.53 30 24.33 30",
  fill: "currentColor"
}));